import { useRef, useEffect } from "react";
function useEventListener(type, listener) {
  const refHandler = useRef(listener);
  useEffect(() => {
    refHandler.current = listener;
  }, [listener]);
  useEffect(() => {
    const isSupported = window && window.addEventListener;
    if (!isSupported) {
      console.warn("Event target does not have an addEventListener method");
      return;
    }
    const handler = (event) => refHandler.current(event);
    window.addEventListener(type, handler);
    return () => {
      window.removeEventListener(type, handler);
    };
  }, [type]);
}
export {
  useEventListener as default
};
//# sourceMappingURL=use-event-listener.js.map
